import { AxiosInstance } from "axios";
import { CredentialSchema, ProfileSchema } from "../../Schemas/User";
import { IResponseBody } from "../../Schemas/EndPoint";

export interface TokenResponseBody extends IResponseBody {
  data: {
    profile: ProfileSchema;
  };
}

export class ProfileRequest {
  private path = "/account/profile";
  private publicAxiosInstance;

  constructor(publicAxiosInstance: AxiosInstance) {
    this.publicAxiosInstance = publicAxiosInstance;
  }

  async send(): Promise<TokenResponseBody> {
    try {
      const { data } = await this.publicAxiosInstance.get(this.path);
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
